<template>
  <div class="delivery-order-container">
    <div class="search-wrapper">
      <div class="search-title">送货订单筛选</div>
      <div class="search-content">
        <el-input v-model="searchForm.orderId" placeholder="请输入订单编号" class="search-item" clearable @keyup.enter.native="handleSearch" />
        <el-input v-model="searchForm.publisherName" placeholder="请输入发布人" class="search-item" clearable @keyup.enter.native="handleSearch" />
        <el-select v-model="searchForm.status" class="search-item" placeholder="订单状态" clearable>
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="searchForm.payState" class="search-item" placeholder="支付状态" clearable>
          <el-option v-for="item in payStateOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </div>
    </div>

    <div class="list-wrapper">
      <div class="list-header">
        <div class="list-title">送货大厅订单管理</div>
      </div>

      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="orderId" label="订单号" min-width="180" show-overflow-tooltip />
        <el-table-column prop="communityId" label="小区" min-width="130" show-overflow-tooltip />
        <el-table-column prop="publisherName" label="发布人" min-width="100" />
        <el-table-column prop="claimerName" label="领取人" min-width="100" />
        <el-table-column prop="goodsType" label="货物" min-width="100" />
        <el-table-column label="费用" min-width="150">
          <template slot-scope="scope">
            {{ money(scope.row.rewardFee) }} + {{ money(scope.row.serviceFee) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="订单状态" min-width="110">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.status)">{{ statusLabel(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="payState" label="支付状态" min-width="110">
          <template slot-scope="scope">
            <el-tag :type="payStateTagType(scope.row.payState)">{{ payStateLabel(scope.row.payState) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="170" show-overflow-tooltip />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              :disabled="!canClose(scope.row)"
              @click="handleClose(scope.row)">
              强制关闭
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="page.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { getDeliveryOrderList, adminCloseDeliveryOrder } from '@/api/dev/deliveryOrderApi'

export default {
  name: 'DeliveryOrderManageList',
  data() {
    return {
      loading: false,
      searchForm: {
        orderId: '',
        publisherName: '',
        status: '',
        payState: ''
      },
      statusOptions: [
        { label: '待抢单', value: 'PUBLISHED' },
        { label: '已抢单', value: 'CLAIMED' },
        { label: '已收货', value: 'RECEIVED' },
        { label: '待确认', value: 'DELIVERED' },
        { label: '已结算', value: 'COMPLETED' },
        { label: '已取消', value: 'CANCELED' }
      ],
      payStateOptions: [
        { label: '待支付', value: 'UNPAID' },
        { label: '已预付', value: 'PREPAID' },
        { label: '已结算', value: 'SETTLED' }
      ],
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const res = await getDeliveryOrderList({
          page: this.page.current,
          row: this.page.size,
          orderId: this.searchForm.orderId,
          publisherName: this.searchForm.publisherName,
          status: this.searchForm.status,
          payState: this.searchForm.payState
        })
        this.tableData = res.data || []
        this.page.total = res.total || 0
      } catch (error) {
        this.$message.error(error.message || '加载送货订单失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.page.current = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        orderId: '',
        publisherName: '',
        status: '',
        payState: ''
      }
      this.page.current = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getList()
    },
    money(value) {
      const amount = Number(value || 0)
      return amount.toFixed(2)
    },
    statusLabel(status) {
      const map = {
        PUBLISHED: '待抢单',
        CLAIMED: '已抢单',
        RECEIVED: '已收货',
        DELIVERED: '待确认',
        COMPLETED: '已结算',
        CANCELED: '已取消'
      }
      return map[status] || status
    },
    statusTagType(status) {
      const map = {
        PUBLISHED: 'warning',
        CLAIMED: '',
        RECEIVED: '',
        DELIVERED: 'warning',
        COMPLETED: 'success',
        CANCELED: 'info'
      }
      return map[status] || 'info'
    },
    payStateLabel(payState) {
      const map = {
        UNPAID: '待支付',
        PREPAID: '已预付',
        SETTLED: '已结算'
      }
      return map[payState] || payState
    },
    payStateTagType(payState) {
      const map = {
        UNPAID: 'danger',
        PREPAID: 'warning',
        SETTLED: 'success'
      }
      return map[payState] || 'info'
    },
    canClose(row) {
      if (!row) {
        return false
      }
      return row.status !== 'COMPLETED' && row.status !== 'CANCELED'
    },
    handleClose(row) {
      this.$confirm(`确认强制关闭订单 ${row.orderId} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await adminCloseDeliveryOrder({
          orderId: row.orderId,
          communityId: row.communityId
        })
        this.$message.success('订单已关闭')
        this.getList()
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.delivery-order-container {
  padding: 15px;
  background-color: #f0f2f5;
}

.search-wrapper,
.list-wrapper {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
}

.search-wrapper {
  margin-bottom: 20px;
}

.search-title,
.list-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.search-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
}

.search-item {
  width: 220px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
